<app-swiper-unit
  [data]="providerList"
  [title]="'game_pro' | translate"
  [titleIcon]="'assets/images/home/sup.svg'"
  [isProvider]="true"
  [hasFavorite]="false"
  [hasHover]="false"
  [hasMask]="false"
  [ratio]="1 / 0.4"
  [titleHref]="'/' + providerHref"
  (clickItem)="clickProviderItem($event)"
  (clickTitle)="clickProviderTitle()"
></app-swiper-unit>
